<template>
<div id="contact">
  <modal v-model="contactSuccess"
         size="sm"
         :header="false"
         @hide="cancel">
    <h3>Demande envoyée</h3>
    <p>
      Votre demande a bien été prise en compte. Nous la traiterons
      dans les plus brefs délais.
    </p>
    <div slot="footer">
      <div class="row">
        <div class="col-xs-12">
          <btn @click="cancel" type="success" block>
            Retourner à la présentation
          </btn>
        </div>
      </div>
    </div>
  </modal>
  <page-section title="Formulaire de contact">
    <div class="col-xs-12 col-sm-offset-1 col-sm-10 col-md-offset-2 col-md-8">
      <p class="text-center">Vous pouvez utiliser le formulaire ci-dessous pour nous contacter</p>
      <div class="row contact-content">
        <div class="col-xs-12">
          <div class="form-group"
               :class="{ 'has-error': nameError }">
            <label for="name" class="control-label">Nom et Prénom</label>
            <input required
                   id="name"
                   tabindex="1"
                   autofocus
                   class="form-control"
                   :disabled="waiting||isLoggedIn"
                   v-model.trim="name"
                   type="text"
                   @blur="checkName()"
                   placeholder="Nom et Prénom"/>
          </div>
          <div v-if="isLoggedIn && establishmentList.length > 0">
            <div class="form-group" :class="{ 'has-error': estabError }">
              <label for="establishment-subscribed" class="control-label">Établissement</label>
              <select
                required
                id="establishment-subscribed"
                tabindex="1"
                autofocus
                class="form-control"
                :disabled="waiting"
                v-model.trim="establishment"
                @blur="checkEstab()"
                placeholder="Établissement">
                <option
                  v-for="e in establishmentList"
                  :value="e"
                  :key="e.key">
                  {{ e.name }} ({{ e.finess }})
                </option>
              </select>
            </div>
          </div>
          <div v-else>
            <div class="form-group" :class="{ 'has-error': estabError }">
              <label for="establishment" class="control-label">Établissement</label>
              <input
                required
                id="establishment"
                tabindex="1"
                autofocus
                class="form-control"
                :disabled="waiting"
                v-model.trim="establishment.name"
                type="text"
                @blur="checkEstab()"
                placeholder="Établissement"/>
            </div>
            <div class="form-group">
              <label for="finess" class="control-label">Numéro Finess</label>
              <input required
                    id="finess"
                    tabindex="1"
                    autofocus
                    class="form-control"
                    :disabled="waiting"
                    v-model.trim="establishment.finess"
                    type="text"
                    placeholder="Finess"/>
            </div>
          </div>
          <div class="form-group" :hidden="isLoggedIn"
               :class="{ 'has-error': jobError }">
            <label for="job" class="control-label">Fonction</label>
            <select required
                    id="job"
                    tabindex="1"
                    autofocus
                    class="form-control"
                    :disabled="waiting"
                    v-model.trim="job"
                    placeholder="Fonction" >
              <option value="" disabled selected>Fonction</option>
              <option v-for="option in jobs"
                      :value="option.name"
                      :key="option.code">
                {{ option.name }}
              </option>
            </select>
          </div>
          <div class="form-group" :hidden="isLoggedIn">
            <label for="phone" class="control-label">Téléphone</label>
            <input required
                   id="phone"
                   tabindex="1"
                   autofocus
                   class="form-control"
                   :disabled="waiting"
                   v-model.trim="phone"
                   type="text"
                   placeholder="Numéro de téléphone"/>
          </div>
          <div class="form-group"
               :class="{ 'has-error': emailError }">
            <label for="email" class="control-label">Adresse e-mail</label>
            <input required
                   id="email"
                   tabindex="1"
                   class="form-control"
                   v-model.trim="email"
                   :disabled="waiting||isLoggedIn"
                   type="email"
                   @blur="checkEmail()"
                   placeholder="Adresse e-mail"/>
          </div>
          <div class="form-group"
               :class="{ 'has-error': bodyError }">
            <label for="body" class="control-label">Message</label>
            <textarea required
                      id="body"
                      tabindex="1"
                      class="form-control"
                      rows="7"
                      v-model.trim="body"
                      :disabled="waiting"
                      @blur="checkBody()"
                      placeholder="Message..."/>
          </div>

          <div class="form-group" v-show="false">
            <input required
                   tabindex="-1"
                   autocomplete="off"
                   id="website"
                   :disabled="waiting"
                   class="form-control"
                   v-model="website"
                   placeholder="empty"/>
          </div>
          <div class="form-group">
            <btn id="send-button"
                 type="success"
                 tabindex="1"
                 :disabled="waiting"
                 @click="send">Envoyer</btn>
          </div>
          <collapse v-model="showError">
            <alert type="danger">
              <strong>{{ errorTitle }}</strong>
              <p>{{ error }}</p>
            </alert>
          </collapse>
        </div>
      </div>
    </div>
  </page-section>
</div>
</template>
<script>
import contact from '@/api/contact'

import browser from '@/sui/tools/browser'
import tools from '@/sui/tools/main'
import pageSection from '@/components/pagesection'

import { mapState, mapGetters } from 'vuex'

export default {
  name: 'contact',

  data () {
    return {
      email: '',
      establishment: {
        name: '',
        finess: ''
      },
      finess: '',
      job: '',
      phone: '',
      body: '',
      name: '',
      website: '',
      contactSuccess: false,
      emailError: false,
      nameError: false,
      estabError: false,
      jobError: false,
      bodyError: false,
      errorTitle: '',
      error: '',
      waiting: false
    }
  },

  mounted () {
    this.reset()
  },

  computed: {
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      userName: 'user/completeName',
      userEmail: 'user/email'
    }),

    ...mapState({
      jobs: state => state.user.jobs,
      surveillances: state => state.surveillances.all
    }),

    establishmentList: function () {
      const result = []
      for (let y in this.surveillances) {
        for (let l of this.surveillances[y]) {
          const e = result.find(e => e.finess === l.establishment.finess)
          if (e == null) {
            result.push(
              {
                finess: l.establishment.finess,
                name: l.establishment.name
              }
            )
          }
        }
      }
      return result
    },

    showError: function () {
      return this.error !== '' || this.errorTitle !== ''
    },

    showLabels: function () {
      return browser.isIE9
    }
  },

  methods: {
    buildBody: function () {
      return `
<p>${this.body}</p>`
    },

    buildSigning: function () {
      const identity = `
<strong>${this.name}</strong><br />
e-mail : ${this.email}<br />`
      const estab = `
établissement : ${this.establishment.name}<br />
finess : ${this.establishment.finess}<br />`
      const logged = `
(<i>Utilisateur enregistré</i>)<br />`

      if (this.isLoggedIn) {
        return `${identity} ${estab} ${logged}`
      } else {
        return `${identity} ${estab}
fonction : ${this.job}<br />
tél : ${this.phone}<br />
(<i>Utilisateur inconnu</i>)<br />`
      }
    },

    reset: function () {
      this.emailError = this.nameError = false
      this.estabError = this.jobErr = this.bodyError = false
      this.waiting = false
      this.email = ''
      this.establishment.name = ''
      this.establishment.finess = ''
      this.job = ''
      this.phone = ''
      this.body = ''
      this.name = ''
      this.website = ''
      this.errorTitle = ''
      this.error = ''

      if (this.isLoggedIn) {
        this.name = this.userName
        this.email = this.userEmail
      }
    },

    send: function () {
      this.errorTitle = ''
      this.error = ''
      if (!this.checkFormContent()) {
        return
      }

      this.waiting = true
      this.emailError = this.nameError = false
      this.estabError = this.jobError = this.bodyError = false
      let instance = this

      contact.sendMail(this.name, this.email, this.buildBody(), this.buildSigning()).then(
        (response) => {
          instance.waiting = false
          if (response.data.err != null) {
            instance.nameError = true
            instance.emailError = true
            instance.estabError = true
            instance.jobError = true
            instance.bodyError = true
            instance.errorTitle = "Echec d'envoi de l'e-mail."
            instance.error = `L'e-mail n'a pas pu être envoyé, vérifiez que vous
utilisez bien une adresse e-mail existante.`
          } else {
            instance.$notify({
              type: 'success',
              title: 'Merci !',
              content: `Votre e-mail a bien été envoyé, nous traiterons votre demande
dans les plus brefs délais.`
            })
            this.reset()
            instance.contactSuccess = true
          }
        }
      ).catch(function (e) {
        instance.waiting = false
        if (e.status === 500) {
          instance.errorTitle = 'Erreur interne.'
          instance.error = `Si cette erreur persiste, merci de contacter
un administrateur.`
        } else {
          instance.errorTitle = 'Serveur injoignable.'
          instance.error = `Merci de vérifier votre connexion internet.`
        }
      })
    },

    checkFormContent: function () {
      return (this.website === '') &&
        this.checkEmail() &&
        this.checkName() &&
        this.checkBody() &&
        this.checkEstab() &&
        this.checkJob()
    },

    checkName: function () {
      this.nameError = (this.name === '')
      this.error = (this.nameError) ? 'Aucun nom saisi.' : ''
      this.errorTitle = ''

      return !this.nameError
    },

    checkEstab: function () {
      if (this.isLoggedIn) {
        return true
      }

      this.estabError = (this.establishment.name === '')
      this.error = (this.estabError) ? 'Aucun établissement saisi.' : ''
      this.errorTitle = ''
      return !this.estabError
    },

    checkJob: function () {
      if (this.isLoggedIn) {
        return true
      }
      this.jobError = (this.job === '')
      this.error = (this.jobError) ? 'Aucune fonction saisie.' : ''
      this.errorTitle = ''
      return !this.jobError
    },

    checkBody: function () {
      this.bodyError = (this.body === '')
      this.error = (this.bodyError) ? 'Aucun message saisi.' : ''
      this.errorTitle = ''

      return !this.bodyError
    },

    checkEmail: function () {
      this.emailError = (this.email === '' || !tools.isEmailValid(this.email))
      this.error = (this.emailError)
        ? 'L\'adresse e-mail saisie est invalide.' : ''
      this.errorTitle = ''

      return !this.emailError
    },

    cancel () {
      this.contactSuccess = false
      this.$router.push('/program')
    }
  },

  components: {
    pageSection
  }
}
</script>
<style scoped lang="less">

#contact {
    min-height: 100rem;

    .contact-content {
        padding-top: 2rem;
        padding-bottom: 10rem;
    }

    div > select{
      padding-left: 8px;
    }
    select:required:invalid {
      color: gray;
      opacity: 0.8;
    }
    option[value=""][disabled] {
      display: none;
    }
    option {
      color: black;
    }
}
</style>
